import { FC } from 'react';
import { Controller, Control, FieldError } from 'react-hook-form';

import PhoneInput from '@/components/controls/PhoneInput.tsx';

export type MobilePhoneInputProps = {
  name: string;
  label?: string;
  control: Control<any, any>;
  error?: FieldError;
  containerClassName?: string;
  labelClassName?: string;
  selectClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
};

const MobilePhoneInput: FC<MobilePhoneInputProps> = ({
  name,
  label = 'Mobile Number',
  control,
  error,
  containerClassName = 'flex flex-col gap-2',
  labelClassName = 'flex flex-col mt-4 text-sm whitespace-nowrap bg-white text-zinc-800',
  selectClassName = 'w-28 p-2 text-base outline-none whitespace-nowrap rounded-lg border border-solid border-zinc-800 text-zinc-800 bg-white',
  inputClassName = 'flex-1 p-2.5 text-base outline-none whitespace-nowrap rounded-lg border border-solid border-zinc-800 text-zinc-800',
  disabled = false,
}) => {
  return (
    <div className={containerClassName}>
      <label htmlFor={`${name}-input`} className={labelClassName}>
        {label}
      </label>

      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur, ref } }) => (
          <PhoneInput
            id={`${name}-input`}
            value={value as string}
            onChange={onChange}
            onBlur={onBlur}
            inputRef={ref}
            selectClassName={selectClassName}
            inputClassName={inputClassName}
            disabled={disabled}
          />
        )}
      />

      {error && (
        <span className="text-red-600 w-full px-2 text-base">
          {error.message}
        </span>
      )}
    </div>
  );
};

export default MobilePhoneInput;
